
import formatPrice from "@/app/infrastructures/misc/common-library/FormatPrice";
import { Vue, prop, Options } from "vue-class-component";
import { AccountController } from "../../controllers/AccountController";

interface CustomStyles {
  background: string;
  text: string;
  border: string;
}

class Props {
  data = prop<any>({
    type: Object,
    default: null
  });
  modelValue = prop<boolean>({
    type: Boolean,
    default: false
  });
  timeout = prop<number>({
    type: Number,
    default: 0
  });
  isCustom = prop<boolean>({
    type: Boolean,
    default: false
  });
  hasChild = prop<boolean>({
    type: Boolean,
    default: false
  });
  customStyles = prop<CustomStyles>({
    type: Object,
    default: null
  });
  icon = prop<string>({
    type: String,
    default: ""
  });
  message = prop<string>({
    type: String,
    default: ""
  });
  isAutoDisplay = prop<boolean>({
    type: Boolean,
    default: true
  });
  isAutoClose = prop<boolean>({
    type: Boolean,
    default: false
  });
  showIconClose = prop<boolean>({
    type: Boolean,
    default: false
  });
  status = prop<string>({
    type: String,
    default: "success"
  });
  messageError = prop<string>({
    type: String,
    default: "Tunggu sampai customers selesai melunasi tagihan kurang bayar"
  });
  titleMessageError = prop<string>({
    type: String,
    default: "No. STT tidak bisa diupdate"
  });
  isSttNo = prop<boolean>({
    type: Boolean,
    default: true
  });
  customIconClose = prop<boolean>({
    type: Boolean,
    default: false
  });
}

@Options({
  emits: ["update:modelValue", "refresh", "close"]
})
export default class Notification extends Vue.with(Props) {
  formatPrice(value: number) {
    return formatPrice(
      value,
      "",
      AccountController.accountData.countryCode === "my" ? "MYR" : "IDR"
    );
  }

  closeNotification() {
    this.$emit("update:modelValue", false);
    this.$emit("close");
  }

  onRefresh(e: any) {
    this.$emit("refresh", e);
    this.closeNotification();
  }

  // update list
  mounted() {
    this.refreshList();
  }

  timer: any = "";
  updated() {
    this.refreshList();
    if (this.isAutoClose) {
      if (this.modelValue) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.closeNotification();
        }, this.timeout * 1000);
      } else {
        this.closeNotification();
      }
    }
  }
  refreshList() {
    if (this.isAutoDisplay && !this.modelValue && this.timeout) {
      setTimeout(() => {
        this.$emit("update:modelValue", true);
      }, this.timeout * 1000);
    }
  }
}
